import React, { useEffect, useState } from 'react';
import axios from '../utils/axiosInstance';
import { useAuth } from '../context/AuthProvider';
import { toast } from 'react-hot-toast';

const AdminUsersPage = () => {
  const { user } = useAuth();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [form, setForm] = useState({ name: '', phone: '', email: '', role: 'user', password: '' });

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = () => {
    axios.get('/users/all')
      .then(res => setUsers(res.data))
      .catch(() => toast.error('Failed to load users'))
      .finally(() => setLoading(false));
  };

  const openModal = (user = null) => {
    setEditingUser(user);
    setForm(user ? { ...user, password: '' } : { name: '', phone: '', email: '', role: 'user', password: '' });
    setShowModal(true);
  };

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      if (editingUser) {
        await axios.put(`/users/${editingUser._id}`, form);
        toast.success('User updated');
      } else {
        await axios.post('/users/add', form);
        toast.success('User created');
      }
      setShowModal(false);
      fetchUsers();
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to save user');
    }
  };

  const deleteUser = async id => {
    if (!window.confirm('Are you sure?')) return;
    try {
      await axios.delete(`/users/${id}`);
      toast.success('User deleted');
      fetchUsers();
    } catch {
      toast.error('Failed to delete user');
    }
  };

  return (
    <div className="w-full max-w-6xl mx-auto px-2 sm:px-6 pb-4">
      <div className="flex flex-col sm:flex-row justify-between items-center mb-4 gap-2">
        <h2 className="text-2xl font-bold text-center w-full sm:w-auto">User Management</h2>
        <button
          onClick={() => openModal()}
          className="w-full sm:w-auto bg-black text-white px-4 py-2 rounded"
        >
          + Add User
        </button>
      </div>


      {loading ? <p>Loading...</p> : (
        <div className="overflow-auto">
          <table className="min-w-full border rounded shadow text-sm">
            <thead className="bg-gray-100">
              <tr>
                <th className="p-1 sm:p-2 border text-xs sm:text-sm">Name</th>
                <th className="p-1 sm:p-2 border text-xs sm:text-sm">Phone</th>
                <th className="p-1 sm:p-2 border text-xs sm:text-sm">Email</th>
                <th className="p-1 sm:p-2 border text-xs sm:text-sm">Role</th>
                <th className="p-1 sm:p-2 border text-xs sm:text-sm">Actions</th>
              </tr>
            </thead>
            <tbody>
              {users.map(u => (
                <tr key={u._id}>
                  <td className="p-1 sm:p-2 border text-xs sm:text-sm">{u.name}</td>
                  <td className="p-1 sm:p-2 border text-xs sm:text-sm">{u.phone}</td>
                  <td className="p-1 sm:p-2 border text-xs sm:text-sm">{u.email || '-'}</td>
                  <td className="p-1 sm:p-2 border text-xs sm:text-sm">{u.role}</td>
                  <td className="p-1 sm:p-2 border text-xs sm:text-sm">
                    <button onClick={() => openModal(u)} className="text-blue-600 mr-2">Edit</button>
                    <button onClick={() => deleteUser(u._id)} className="text-red-600">Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-4 sm:p-6 w-full max-w-md mx-2">
            <h3 className="text-xl font-semibold mb-4">{editingUser ? 'Edit User' : 'Add User'}</h3>
            <form onSubmit={handleSubmit} className="space-y-4">
              <input name="name" placeholder="Name" value={form.name} onChange={handleChange} className="w-full border p-2 rounded" required />
              <input name="phone" placeholder="Phone" value={form.phone} onChange={handleChange} className="w-full border p-2 rounded" required />
              <input name="email" placeholder="Email" value={form.email} onChange={handleChange} className="w-full border p-2 rounded" />
              <select name="role" value={form.role} onChange={handleChange} className="w-full border p-2 rounded">
                <option value="admin">Admin</option>
                <option value="factory">Factory Staff</option>
                <option value="customer-service">Customer Service</option>
                <option value="user">User</option>
              </select>
              {!editingUser && (
               <input
  name="password"
  placeholder={editingUser ? "New Password (leave blank to keep current)" : "Password"}
  value={form.password}
  onChange={handleChange}
  type="password"
  className="w-full border p-2 rounded"
  required={!editingUser}
/>


              )}
              <div className="flex justify-end gap-2">
                <button type="button" onClick={() => setShowModal(false)} className="px-4 py-2 border rounded">Cancel</button>
                <button type="submit" className="px-4 py-2 bg-green-600 text-white rounded">Save</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminUsersPage;
